import React from "react";
import { AbstructLang } from "./AbstructLang";
import { AbstructVar } from "./AbstructVar";
import SelectDropDown from "../../../elements/SelectDropDown";
import InputCustom from "../../../elements/InputCustom";
import { useSelectorCustom } from "./useSelectorCustom";

function Form({
  props,
  langLocal,
  fields,
  handleSubmit,
  state,
  setStateCustom,
  buttonLabel,
}) {
  const { translate } = AbstructLang();
  const { currency } = useSelectorCustom();
  const handleFieldChange = (name, value) => {
    setStateCustom(name, value);
  };
  const renderInputField = (field) => {
    if (field.inputType === "text") {
      return (
        <InputField
          key={field.name}
          label={field.label}
          iconType={field.iconType}
          type={field.type}
          value={state[field.name] || ""} // Ensure value is not undefined
          onChange={(newValue) => setStateCustom(field.name, newValue)}
          langLocal={langLocal}
          disabled={field.disabled}
          currency={currency}
        />
      );
    } else if (field.inputType === "textArea") {
      return (
        <TextareaField
          key={field.name}
          label={field.label}
          iconType={field.iconType}
          type={field.type}
          value={state[field.name] || ""} // Ensure value is not undefined
          onChange={(e) => setStateCustom(field.name, e.target.value)}
          langLocal={langLocal}
          disabled={field.disabled}
          currency={currency}
        />
      );
    } else if (field.inputType === "select") {
      return (
        <SelectField
          key={field.name}
          label={field.label}
          iconType={field.iconType}
          options={field.options}
          value1={state[field.name]}
          is_name={field.is_name}
          is_id={field.is_id}
          onChange={(e) => setStateCustom(field.name, e.target.value)}
          langLocal={langLocal}
        />
      );
    } else if (field.inputType === "one_select") {
      return (
        <OneSelect
          key={field.name}
          label={field.label}
          iconType={field.iconType}
          options={field.options}
          value={state[field.name]}
          onChange={(selectedOption) =>
            setStateCustom(field.name, selectedOption)
          }
          langLocal={langLocal}
          defaultvaluee={field.defaultvaluee}
        />
      );
    } else if (field.inputType === "file") {
      return (
        <div style={{ width: "100%" }}>
          <InputCustom
            label={field.label}
            iconType="file"
            type="file"
            value={state[field.name]}
            service_name={field.service_name}
            onChange={handleFieldChange}
            typeFileOne
            name={field.name}
          />
        </div>
      );
    } else if (field.inputType === "multi_select") {
      return (
        <MultiSelect
          key={field.name}
          label={field.label}
          iconType={field.iconType}
          options={field.options}
          value={state[field.name]}
          onChange={(selectedOption) =>
            setStateCustom(field.name, selectedOption)
          }
          langLocal={langLocal}
          defaultvaluee={field.defaultvaluee}
        />
      );
    } else if (field.inputType === "checkbox") {
      return (
        <CheckboxField
          key={field.name}
          label={field.label}
          checked={state[field.name] || false}
          onChange={(e) => setStateCustom(field.name, e.target.checked)}
          langLocal={langLocal}
          disabled={field.disabled}
        />
      );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {fields.map((field) => renderInputField(field))}
      <div className="div_popup_btn">
        <button>{state.Load ? "Loading .." : translate(buttonLabel)}</button>
      </div>
    </form>
  );
}

function InputField({
  currency,
  langLocal,
  label,
  iconType,
  type,
  value,
  onChange,
  disabled,
}) {
  const { translate } = AbstructLang();
  let { mode } = AbstructVar();
  // Function to format number with commas
  const formatNumber = (number) => {
    return number.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Handle input change and format number if type is 'text' and label is 'amount'
  const handleChange = (e) => {
    let newValue = e.target.value;
    if (
      type === "text" &&
      (label === "amount" || label === "remaining_amount")
    ) {
      newValue = formatNumber(newValue);
    }
    onChange(newValue);
  };

  return (
    <div dir={langLocal === "ar" ? "rtl" : "ltr"}>
      <p
        className={`${mode === "dark" ? "darktext" : "lighttext"} ${
          langLocal === "ar" ? "textAlignRight" : ""
        }`}
      >
        {translate(label)}
      </p>
      <div className="around_input">
        <i
          className={`fa fa-${iconType} ${
            langLocal === "ar"
              ? "border-left padding-left-15"
              : "border-right padding-right-15"
          }`}
        ></i>
        <input
          disabled={disabled}
          className={mode === "dark" ? "darktext" : "lighttext"}
          type={type}
          value={value || ""} // Ensure value is not undefined
          onChange={handleChange}
        />
        {(label === "amount" || label ===  "remaining_amount") && (
          <span
            style={langLocal === "ar" ? { left: "10px" } : { right: "10px" }}
            className="currency-amount"
          >
            {translate(currency)}
          </span>
        )}
      </div>
    </div>
  );
}

// SelectField component
function SelectField({
  langLocal,
  label,
  iconType,
  value1,
  onChange,
  options,
  is_name,
}) {
  const { translate } = AbstructLang();
  let { mode } = AbstructVar();
  return (
    <div dir={langLocal === "ar" ? "rtl" : "ltr"}>
      <p
        className={`${mode === "dark" ? "darktext" : "lighttext"} ${
          langLocal === "ar" ? "textAlignRight" : ""
        }`}
      >
        {translate(label)}
      </p>
      <div className="around_input">
        <i
          className={`fa fa-${iconType}  ${
            langLocal === "ar"
              ? "border-left padding-left-15"
              : "border-right padding-right-15"
          }`}
        ></i>
        {console.log(options)}
        {value1}
        <select
          className={mode === "dark" ? "darktext" : "lighttext"}
          value={value1}
          onChange={onChange}
          style={{ padding: "20px" }}
        >
          {/*<option disabled="disabled">{translate(label)}</option>*/}
          {is_name
            ? options.map((option, index) => (
                <option key={index} value={option.id}>
                  {translate(option.name)}
                </option>
              ))
            : options.map((option, index) => (
                <option key={index} value={option}>
                  {translate(option)}
                </option>
              ))}
        </select>
      </div>
    </div>
  );
}

function OneSelect({
  langLocal,
  label,
  options,
  value,
  onChange,
  defaultvaluee,
}) {
  const { translate } = AbstructLang();
  let { mode } = AbstructVar();
  return (
    <div dir={langLocal === "ar" ? "rtl" : "ltr"}>
      <p
        className={`${mode === "dark" ? "darktext" : "lighttext"} ${
          langLocal === "ar" ? "textAlignRight" : ""
        }`}
      >
        {translate(label)}
      </p>
      <div style={{ marginBottom: "17px" }}>
        <SelectDropDown
          options={options}
          value1={value}
          setVarr={onChange}
          placeholder={`Select`}
          //multi={true}
          defaultvalue={defaultvaluee}
        />
      </div>
    </div>
  );
}

function MultiSelect({
  langLocal,
  label,
  options,
  value,
  onChange,
  defaultvaluee,
}) {
  const { translate } = AbstructLang();
  let { mode } = AbstructVar();
  return (
    <div dir={langLocal === "ar" ? "rtl" : "ltr"}>
      <p
        className={`${mode === "dark" ? "darktext" : "lighttext"} ${
          langLocal === "ar" ? "textAlignRight" : ""
        }`}
      >
        {translate(label)}
      </p>
      <div style={{ marginBottom: "17px" }}>
        <SelectDropDown
          multi
          options={options}
          value1={value}
          setVarr={onChange}
          placeholder={`Select`}
          defaultvalue={defaultvaluee}
          arrayofnumber
        />
      </div>
    </div>
  );
}
function TextareaField({
  langLocal,
  label,
  iconType,
  type,
  value,
  onChange,
  disabled,
}) {
  const { translate } = AbstructLang();
  let { mode } = AbstructVar();
  return (
    <div dir={langLocal === "ar" ? "rtl" : "ltr"}>
      <p
        className={`${mode === "dark" ? "darktext" : "lighttext"} ${
          langLocal === "ar" ? "textAlignRight" : ""
        }`}
      >
        {translate(label)}
      </p>
      <div className="around_input">
        <textarea
          disabled={disabled}
          className={`${
            mode === "dark" ? "darktext" : "lighttext"
          } TextareaField`}
          type={type}
          defaultValue={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
}
function CheckboxField({ langLocal, label, checked, onChange, disabled }) {
  const { translate } = AbstructLang();
  let { mode } = AbstructVar();

  return (
    <div dir={langLocal === "ar" ? "rtl" : "ltr"}>
      <label
        className={`${mode === "dark" ? "darktext" : "lighttext"} ${
          langLocal === "ar" ? "textAlignRight" : ""
        }`}
      >
        <div className="around_checkbox">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span
          className={langLocal === "ar" ? "margin_right_10" : "margin_left_10"}
        >
          {translate(label)}
        </span>
        </div>
   
      </label>
    </div>
  );
}

export {
  Form,
  InputField,
  TextareaField,
  SelectField,
  OneSelect,
  CheckboxField,
};
